module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mu-468d5464b2219b1bb9227af74e552fef.svg";